import { render, staticRenderFns } from "./SoftwareResourceCard.vue?vue&type=template&id=056f4233&"
import script from "./SoftwareResourceCard.vue?vue&type=script&lang=ts&"
export * from "./SoftwareResourceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports